<template>
    <div class="app">
        <scroll v-pull="refresh">
            <no-record :condition="physicalExamInfo" tips='暂无体检报告记录'></no-record>
            <section class="thick" v-for="(physicalItem, index) in physicalExamInfo.physicalItems">
                <div class="panel">
                    <span class="f-strong">体检报告{{index + 1}}</span>
                </div>
                <div class="row arr-row table-row">
                    <div class="col">
                        <span class="f-minor">体检时间</span>&nbsp;&nbsp;<span
                            class="f-minor">{{physicalItem.examDate | formatDate}}</span>
                    </div>
                    <div class="col">
                        <button @click.stop="goPhysicalDetail(index)" class="btn-minor-blue btn-position">查看</button>
                    </div>
                </div>
            </section>
        </scroll>
    </div>
</template>
<script>
    import recordService from 'record.service'
    import NoRecord from 'NoRecord';
    export default {
        components: {
            NoRecord
        },
        data() {
            return {
                physicalExamInfo: {
                    "totalNum": 0,
                    "physicalItems": [
//                        {
//                            "examDate": "2016-01-01",
//                            "evaluation": "体检无异常",
//                            "guidance": "多运动",
//                            "riskControl": ""
//                        }
                    ]
                },
                curPage: 1
            }
        },
        created() {
            this.refresh();
        },
        methods: {
            refresh() {
                var voucher = this.$store.state.paramModule.param.healthRecord.voucher;
                recordService.getPhysicalExam({cardNo: voucher.cardNo, cardType: voucher.cardType, curPage: this.curPage}).then((res) => {
                    if (res.physicalItems.length > 0) {
                        this.physicalExamInfo.physicalItems = this.physicalExamInfo.physicalItems.concat(res.physicalItems);
                        this.curPage = this.curPage + 1;
                    }
                });
            },

            goPhysicalDetail(index) {
                this.$store.commit('updateParam', {
                    namespace: 'healthRecord',
                    physicalItem: this.physicalExamInfo.physicalItems[index],
                });
                this.$router.push('PhysicalExamDetail');
            },
        }
    }
</script>


// WEBPACK FOOTER //
// PhysicalExam.vue?5223884a